import { Controller } from "@hotwired/stimulus"

// Handles drag-drop and file selection for single file uploads.
// Drag events are bound via data-action attributes in the view:
//   data-action="dragover->file-input#onDragOver dragleave->file-input#onDragLeave drop->file-input#onDrop"
export default class extends Controller {
  static targets = ["input", "filename", "placeholder", "preview", "dropzone"]

  click() {
    this.inputTarget.click()
  }

  select() {
    const file = this.inputTarget.files[0]
    if (file) {
      this.showFile(file)
    }
  }

  onDragOver(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.add("border-teal-500", "bg-teal-50")
    this.dropzoneTarget.classList.remove("border-gray-300")
  }

  onDragLeave(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.remove("border-teal-500", "bg-teal-50")
    this.dropzoneTarget.classList.add("border-gray-300")
  }

  onDrop(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.remove("border-teal-500", "bg-teal-50")
    this.dropzoneTarget.classList.add("border-gray-300")

    const files = Array.from(event.dataTransfer.files)
    if (files.length === 0) return

    // Only take the first file (single file upload)
    const file = files[0]

    const dataTransfer = new DataTransfer()
    dataTransfer.items.add(file)
    this.inputTarget.files = dataTransfer.files

    this.showFile(file)
  }

  showFile(file) {
    this.filenameTarget.textContent = file.name
    this.filenameTarget.classList.remove("hidden")
    this.placeholderTarget.classList.add("hidden")

    if (file.type.startsWith("image/")) {
      const reader = new FileReader()
      reader.onload = (e) => {
        this.previewTarget.src = e.target.result
        this.previewTarget.classList.remove("hidden")
      }
      reader.onerror = () => {
        console.error('Failed to read image preview:', reader.error)
      }
      reader.readAsDataURL(file)
    } else {
      this.previewTarget.classList.add("hidden")
    }
  }
}
